<style lang="scss" src="./SolicitudesHistoricasList.scss"></style>
<template src="./SolicitudesHistoricasList.html"></template>

<script>
// import csvToJson from "convert-csv-to-json";
// import csvToJson from "@/components/Shared/ExportToFile/ExportToJSON"
import papa from 'papaparse'
import { Breadcrumb, BreadcrumbItem, Button, Dialog } from "element-ui";
import ExportToFile from "@/components/Shared/ExportToFile/ExportToFile";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import moment from "moment-timezone";
import { FechaMaximaReclamacionMixin } from "@/mixins/FechaMaximaReclamacionMixin";
import { requestSolicitudMixin } from "@/api/solicitudPH";
import { NotifyMixin } from "@/mixins/NotifyMixin";
import { ExportToFileMixin } from "@/mixins/exportToFile";
import { utils } from "@/utils";
import { RouterMixin } from "@/mixins/routerMixin";
import SolicitudesHistoricasTable from "@/components/Ciudadano/SolicitudesHistoricas/SolicitudesHistoricasTable/SolicitudesHistoricasTable";
import { BrotliMixin } from "@/mixins/BrotliMixin";

export default {
  name: "SolicitudesHistoricasList",
  components: {
    SolicitudesHistoricasTable,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    ExportToFile,
  },
  mixins: [
    requestSolicitudMixin,
    NotifyMixin,
    ScreenSizeMixin,
    FechaMaximaReclamacionMixin,
    ExportToFileMixin,
    RouterMixin,
    BrotliMixin,
  ],
  data: () => ({
    loading: false,
    errored: false,
    inRoute: false,
    dlgExportToFile: false,
    querySearch: "",
    dateFilter: [],
    header: [
      "N° Folio",
      "Rut",
      "Nombre",
      "Correo",
      "Fecha de ingreso",
      "Estado",
    ],
    filter: [
      "folio",
      "run",
      "nombre",
      "correo",
      "solicitud_fecha_ingreso",
      "estado_publico",
    ],
    disabled: [true, false, false, false, true, false],
  }),
  computed: {
    fieldsToExport: function () {
      const list = this.header.map((h, i) => ({
        name: h,
        key: this.filter[i],
        disabled: this.disabled[i],
      }));
      this.$log.debug(list);
      return list;
    },
  },
  beforeMount() {
    if (this.$route.name === "solicitudes-historicas") {
      this.inRoute = true;
    }
  },
  methods: {
    onView(id) {
      this.$log.debug("onView", id);
      this.navigate({
        name: "solicitud-historica-view-id",
        params: { id: id },
      });
    },
    exportToFile(querySearch = "", dateFilter = []) {
      this.$log.debug("exportToFile", querySearch, dateFilter);
      this.querySearch = querySearch;
      this.dateFilter = dateFilter;

      this.dlgExportToFile = true;
    },
    closeDlgExport() {
      this.dlgExportToFile = false;
    },
    async exportToExcel(checkList, fields) {
      this.$log.debug("exportToExcel");
      const listField = this.getListField(checkList, fields);
      const data = await this.getList({fields: listField});
      if (!this.errored) {
        const date = moment().format("YYYYMMDDhhmmss");
        const filename = `solicitudes-historicas-${date}`;
        this.exportExcel(data, checkList, fields, filename);
      }
    },
    async exportToPdf(checkList, fields) {
      this.$log.debug("exportToPdf");
      const listField = this.getListField(checkList, fields);
      const data = await this.getList({fields: listField});
      if (!this.errored) {
        const date = moment().format("YYYYMMDDhhmmss");
        const filename = `solicitudes-historicas-${date}`;
        this.exportPdf(data, checkList, fields, filename);
      }
    },
    getList({
      pageAll = true,
      search = this.querySearch,
      dateRange = this.dateFilter,
      fields = fields,
      format = "csv",
      compress = true,
    } = {}) {
      this.loading = true;
      const pagingQuery = {
        pageAll: pageAll,
        search: search,
        dateRange: dateRange,
        fields: fields,
        format: format,
        compress: compress,
      };

      const loading = this.getLoading();

      return this.getListaSolicitud(pagingQuery)
        .then((response) => {
          this.$log.debug("getListaSolicitud", response.data.statusCode);

          if (response.data.statusCode === 200) {
            this.$log.debug(response.data.datos);
            const data = this.decompress(response.data.datos);
            this.$log.debug(data);
            let dataformat = data;
            if (pagingQuery.format === "csv") {
              // dataformat = csvToJson.fieldDelimiter(";").csvStringToJson(data);
              dataformat =  papa.parse(data)
            }

            const datasource = dataformat.map((row) => {
              row.run = utils.rutFilter(row.run);
              row.solicitud_fecha_ingreso = moment
                .utc(row.solicitud_fecha_ingreso)
                .format("DD-MM-YYYY HH:mm");
              return row;
            });
            this.$log.debug(datasource);
            this.errored = false;

            return datasource;
          } else {
            this.errored = true;
            this.showError("Ocurrió un error inesperado al cargar los datos");
          }
          return [];
        })
        .catch((err) => {
          this.$log.fatal("getListaSolicitud", err, err.response, err.request);
          this.errored = true;
          this.showError("Ocurrió un error inesperado al cargar los datos");
        })
        .finally(() => {
          this.loading = false;
          loading.close();
        });
    },
  },
};
</script>
